export { default } from "./spinner";
